export const codesUploadDocumentsToCharge = [
  {
    name: 'Cédula',
    prefix: 'CC',
    code: 254
  },
  {
    name: 'Certificación de ingresos',
    prefix: 'CI',
    code: 631
  },
  {
    name: 'Declaración de renta del último año',
    prefix: 'DR',
    code: 260
  },
  {
    name: 'Certificación laboral',
    prefix: 'CL',
    code: 255
  },
  {
    name: 'Contrato de prestación de servicios',
    prefix: 'CPS',
    code: 255
  },
  {
    name: 'Último comprobante de nómina',
    prefix: 'CN',
    code: 256
  },
  {
    name: 'Último comprobante de pensión',
    prefix: 'CP',
    code: 256
  },
  {
    name: 'Estados financieros',
    prefix: 'EF',
    code: 259
  },
  {
    name: 'Cámara de comercio',
    prefix: 'CCO',
    code: 261
  },
  {
    name: 'RUT',
    prefix: 'RUT',
    code: 677
  },
  {
    name: 'Resolución de liquidación',
    prefix: 'RL',
    code: 257
  }
];
